import { BrowserRouter } from 'react-router-dom';
import { ApolloClient } from '@/libs/apollo-client';
import { Box } from '@mui/material';
import getInitColorSchemeScript from '@mui/system/cssVars/getInitColorSchemeScript';
import { GlobalLoadingProvider } from '@/providers/global-loading-provider';
import { NavigationProvider } from '@/providers/navigation-provider';
import { PHProvider } from '@/providers/posthog-provider';
import PostHogPageView from '@/PostHogPageView';
import { SnackbarProvider } from './providers/notistack-provider';
import AppRoutes from './AppRoutes';
import LocalizationProvider from './providers/localization-provider';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Crisp } from 'crisp-sdk-web';
import { useEffect } from 'react';

function App() {
    useEffect(() => {
        Crisp.configure(import.meta.env.VITE_CRISP_ID);
        // Crisp Chat Behavior
        Crisp.chat.hide();
        Crisp.chat.onChatClosed(() => {
            Crisp.chat.hide();
        });

        Crisp.message.onMessageReceived(() => {
            Crisp.chat.show();
        });
    }, []);

    return (
        <>
            <BrowserRouter>
                <PHProvider>
                    <PostHogPageView />
                    <ApolloClient>
                        <GlobalLoadingProvider>
                            <NavigationProvider>
                                <SnackbarProvider>
                                    <LocalizationProvider>
                                        <Box sx={{ display: 'flex' }}>
                                            {getInitColorSchemeScript()}
                                            <AppRoutes />
                                        </Box>
                                    </LocalizationProvider>
                                </SnackbarProvider>
                            </NavigationProvider>
                        </GlobalLoadingProvider>
                    </ApolloClient>
                </PHProvider>
            </BrowserRouter>
        </>
    );
}

export default App;
